var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"password-errors"},_vm._l((_vm.errorValidations),function(validation,index){return _c('li',{key:'error' + index,class:{ 'password-errors--passed': !_vm.hasError(validation.message) },attrs:{"id":validation.name + '-validation'}},[_c('span',{class:[
        { 'password-errors-status--passed': !_vm.hasError(validation.message) },
        'password-errors-status',
      ]}),_vm._v("\n    "+_vm._s(validation.message)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }